import { createActions } from 'redux-actions';
import keyMirror from 'key-mirror';

export const constants = keyMirror({
    SESSION_TOKEN_REQUEST: null,
    SESSION_TOKEN_SUCCESS: null,
    SESSION_TOKEN_FAILURE: null,

    DELETE_TOKEN_REQUEST: null,
    DELETE_TOKEN_SUCCESS: null,

    SAVE_TOKEN_REQUEST: null,
    SAVE_TOKEN_SUCCESS: null,

    LOGOUT_REQUEST: null,
    LOGOUT_SUCCESS: null,
    LOGOUT_FAILURE: null,

    LOGIN_REQUEST: null,
    LOGIN_SUCCESS: null,
    LOGIN_FAILURE: null,

    SIGNUP_REQUEST: null,
    SIGNUP_SUCCESS: null,
    SIGNUP_FAILURE: null,

    SIGNUP_SCHOOL_SEARCH_REQUEST: null,
    SIGNUP_SCHOOL_SEARCH_SUCCESS: null,
    SIGNUP_SCHOOL_SEARCH_FAILURE: null,

    FORGET_PASSWORD_REQUEST: null,
    FORGET_PASSWORD_SUCCESS: null,
    FORGET_PASSWORD_FAILURE: null,
});

export const {
    deleteTokenRequest,
    deleteTokenSuccess
} = createActions(constants.DELETE_TOKEN_REQUEST, constants.DELETE_TOKEN_SUCCESS);

export const {
    saveTokenRequest,
    saveTokenSuccess
} = createActions(constants.SAVE_TOKEN_REQUEST, constants.SAVE_TOKEN_SUCCESS);

export const {
    logoutRequest,
    logoutSuccess,
    logoutFailure
} = createActions(constants.LOGOUT_REQUEST, constants.LOGOUT_SUCCESS, constants.LOGOUT_FAILURE);

export const {
    signupRequest,
    signupSuccess,
    signupFailure
} = createActions(constants.SIGNUP_REQUEST, constants.SIGNUP_SUCCESS, constants.SIGNUP_FAILURE);

export const {
    signupSchoolSearchRequest,
    signupSchoolSearchSuccess,
    signupSchoolSearchFailure
} = createActions(
    constants.SIGNUP_SCHOOL_SEARCH_REQUEST,
    constants.SIGNUP_SCHOOL_SEARCH_SUCCESS,
    constants.SIGNUP_SCHOOL_SEARCH_FAILURE
);

export const {
    sessionTokenRequest,
    sessionTokenSuccess,
    sessionTokenFailure
} = createActions(
    constants.SESSION_TOKEN_REQUEST,
    constants.SESSION_TOKEN_SUCCESS,
    constants.SESSION_TOKEN_FAILURE
);

export const {
    loginRequest,
    loginSuccess,
    loginFailure
} = createActions(constants.LOGIN_REQUEST, constants.LOGIN_SUCCESS, constants.LOGIN_FAILURE);

export const {
    forgetPasswordRequest,
    forgetPasswordSuccess,
    forgetPasswordFailure
} = createActions(
    constants.FORGET_PASSWORD_REQUEST,
    constants.FORGET_PASSWORD_SUCCESS,
    constants.FORGET_PASSWORD_FAILURE
);



/** WEBPACK FOOTER **
 ** ./src/core/auth/authActions.js
 **/